import Loader from "@components/Loader";
import ModalConfirmation from "@components/ModalConfirmation";
import ModalUploadProgress from "@components/ModalUploadProgress";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import { EModalUploadProgress } from "@enums/modalUploadProgress";
import getModuleName from "@helpers/modules";
import useCreateItem from "@hooks/Shared/useCreateItem";
import { ElementType, ReactElement } from "react";
import { Form } from "react-final-form";
import { useLocation } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { THookCreate } from "types/Shared/hooks";

interface ICreate {
  CustomForm: ElementType;
  createHook: THookCreate;
  validator: (FormValues: Record<string, any>) => any;
  formMapper: (FormValues: any) => any;
}

const Create = ({
  CustomForm,
  createHook,
  validator,
  formMapper,
}: ICreate): ReactElement => {
  const { pathname } = useLocation();
  const {
    isCreating,
    isModalOpen,
    handleSaveForm,
    handleCreate,
    handleIsModalOpen,
    totalFiles,
    totalSize,
    uploadedFiles,
    uploadedSize,
    isProgressOpen,
  } = useCreateItem();

  return (
    <Container>
      <ModalConfirmation
        icon="plus-circle"
        title={`${getModuleName(pathname)} | Create confirmation`}
        body={"Are you sure you want to create this item?"}
        handleConfirm={() => {
          handleCreate(createHook);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.SUCCESS}
      />

      <ModalUploadProgress
        modalStatus={isProgressOpen}
        modalType={EUiStates.WARNING}
        status={EModalUploadProgress.UploadInProgress}
        uploadedFiles={uploadedFiles}
        totalFiles={totalFiles}
        uploadedSize={uploadedSize}
        totalSize={totalSize}
      />

      <Title />
      <Row>
        <Col xs={12} md={12} lg={12} xl={10}>
          <Card>
            <CardBody>
              <Form
                onSubmit={(FormValues) => {
                  handleSaveForm(FormValues, formMapper);
                }}
                validate={validator}
              >
                {({ handleSubmit, form }) =>
                  isCreating ? (
                    <Loader isInsideThing />
                  ) : (
                    <CustomForm handleSubmit={handleSubmit} form={form} />
                  )
                }
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Create;
